import type { StatusColorGroup } from './statusDefinitions';

/**
 * The shared colour enum (piece 3, Button): six members, and a caller never
 * passes a hex. Navy is the default and the Modal shell's Primary; Destructive
 * paints in the error group and routes its action through the typed-phrase
 * dialog (decision 0093); the four status members paint in their own groups,
 * so six colours introduce no fifth status group.
 */
export enum Color {
  Navy = 'Navy',
  Destructive = 'Destructive',
  Good = 'Good',
  Warning = 'Warning',
  Error = 'Error',
  Inactive = 'Inactive',
}

export const colors = [Color.Navy, Color.Destructive, Color.Good, Color.Warning, Color.Error, Color.Inactive] as const;

/** The status group a colour paints in; Navy paints in the brand colour and belongs to none. */
export function colorStatusGroup(color: Color): StatusColorGroup | null {
  switch (color) {
    case Color.Destructive:
    case Color.Error:
      return 'error';
    case Color.Good:
      return 'good';
    case Color.Warning:
      return 'warning';
    case Color.Inactive:
      return 'inactive';
    default:
      return null;
  }
}
